import { data } from 'services';
import { getShortRFID } from 'services/types';

export const meanTypesMap = {
  rfid: 'RFID',
  card: 'БСК',
  vehicle_plate: 'ГРЗ',
  subscription: 'Абонемент',
};

export const meanTypesMapRights = {
  rfid: 'rfid',
  card: 'csc',
  vehicle_plate: 'plates',
  subscription: 'subscriptions',
};

export const meanTypes = Object.keys(meanTypesMap).map((el) => {
  return { name: meanTypesMap[el], value: el };
});

export const getMeanTypeForRight = (val) => {
  return meanTypesMapRights[val] ?? val;
};

export const getMeanType = (val) => {
  return meanTypesMap[val] ?? '';
};

export const getStatus = (row) => {
  // console.log("row", row);
  // rfid
  if (row.mean_type === 'rfid') {
    return data.getDictValue('rfid.status', row.status);
  }

  // plate
  if (row.mean_type === 'vehicle_plate') {
    return data.getDictValue('plates.list', row.is_blocked);
  }

  return data.getDictValue('payment_mean.status', row.is_blocked);
};

export const getMeanValue = (val, row) => {
  if (['rfid'].includes(row.mean_type)) {
    return getShortRFID(val);
  }
  return val;
};
